module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticClass: "title"
  }, [_vm._v("KONTAKT Z PROJEKTANTEM")])], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "title2"
  }, [_vm._v("Magdalena Dziełakowska")]), _vm._v(" "), _c('p', [_vm._v("Zakres pomocy: Projektowanie w PV*Sol oraz ekonomika inwetycji")]), _vm._v(" "), _c('v-subheader', {
    staticClass: "title2"
  }, [_vm._v("Piotr Szymański")]), _vm._v(" "), _c('p', [_vm._v("Zakres pomocy: Nadzór nad projektami oraz kontakt z dostawcami energii")]), _vm._v(" "), _c('v-subheader', {
    staticClass: "title2"
  }, [_vm._v("Tomasz Tokarski")]), _vm._v(" "), _c('p', [_vm._v("Zakres pomocy: Wykonywanie pomiarów i zdjęć dronem oraz modeli 3d")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-container', [_c('v-select', {
    attrs: {
      "items": _vm.projektant,
      "label": "Wybierz projektanta"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Temat"
    },
    model: {
      value: (_vm.koszt),
      callback: function($$v) {
        _vm.koszt = $$v
      },
      expression: "koszt"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Treść pytania",
      "type": "number"
    },
    model: {
      value: (_vm.moc),
      callback: function($$v) {
        _vm.moc = $$v
      },
      expression: "moc"
    }
  }), _vm._v(" "), _c('v-btn', [_vm._v("Wyślij")])], 1)], 1), _vm._v(" "), (!_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd2bccd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App2.vue
// module id = 162
// module chunks = 1